import {
  TellentRoute,
  TellentRouteFactoryFn,
  TellentClientHomepageID,
  TellentHomeRouteFactoryFn,
  TellentRouteHomepage,
  TellentClientSettingsHomepageID,
  TellentSettingsHomeRouteFactoryFn,
  TellentRouteSettingsHomepage,
} from '@core/tellent-types';

const exactMatch = (location: string, path: string) => location === path;

export const tellentRouteFactory: TellentRouteFactoryFn = (
  id,
  urlStrOrFactory,
  options?,
): TellentRoute => {
  let buildPath;

  if (typeof urlStrOrFactory === 'string') buildPath = () => urlStrOrFactory;

  if (typeof urlStrOrFactory === 'function') buildPath = urlStrOrFactory;

  if (!buildPath) {
    throw new Error(`[Tellent] Invalid route url factory for ${id}`);
  }

  const matchPath = options?.matchPath ?? exactMatch;
  const matchPattern = (location: string) => {
    const urlOrStr = typeof urlStrOrFactory === 'string' ? urlStrOrFactory : urlStrOrFactory({});
    return matchPath(location, urlOrStr);
  };

  const testId = options?.testId ?? `sidebar:${id}`;
  const walkthroughId = options?.walkthroughId;

  return {
    id,
    testId,
    walkthroughId,
    buildPath,
    matchPath,
    matchPattern,
  };
};

export const tellentHomeRouteFactory: TellentHomeRouteFactoryFn = (
  path,
  options,
): TellentRouteHomepage => {
  const matchPath = options?.matchPath ?? exactMatch;
  const matchPattern = (location: string) => matchPath(location, path);

  return {
    id: TellentClientHomepageID,
    testId: TellentClientHomepageID,
    walkthroughId: undefined,
    buildPath: () => path,
    matchPath,
    matchPattern,
  };
};

export const tellentHomeSettingsRouteFactory: TellentSettingsHomeRouteFactoryFn = (
  path,
  options,
): TellentRouteSettingsHomepage => {
  const matchPath = options?.matchPath ?? exactMatch;
  const matchPattern = (location: string) => matchPath(location, path);

  return {
    id: TellentClientSettingsHomepageID,
    testId: TellentClientSettingsHomepageID,
    walkthroughId: undefined,
    buildPath: () => path,
    matchPath,
    matchPattern,
  };
};

export const parametrizedRoutePath =
  <P extends Record<string, string>>(str: string) =>
  (params?: P) =>
    params ? Object.entries(params).reduce((acc, [k, v]) => acc.replace(`:${k}`, v), str) : str;
